import HttpService from '../../../services/HttpService';

export const getAllUsers = async (params: any) => {  
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users`, {
    params: {
      ...params
    }
  });
  return resp.data;
}; 